export const otherLegalEntities = [
  {
    id: '001',
    label:
      'Breve reseña de la empresa',
  },
  {
    id: '002',
    label: 'Declaración de Ganancias',
  },
  {
    id: '003',
    label: 'Declaración de Bienes Personales',
  },
  {
    id: '004',
    label: 'Ventas Mensuales del Último Año',
  },
  {
    id: '005',
    label: 'Deudas Actualizadas',
  },
  {
    id: '006',
    label: 'Certificado Pyme',
  },
  {
    id: '007',
    label: 'Manifestación de Bienes firmado por contador',
  },
  {
    id: '008',
    label:
      'Detalle de la composición accionaria (indicando CUIT de los socios y %)',
  },
  {
    id: '009',
    label: 'Último Estado Contable certificado',
  },
  {
    id: '010',
    label: 'Ventas Post Balance',
  },
  {
    id: '011',
    label: 'Otros',
  },
  {
    id: '012',
    label: 'Actas de modificación al estatuto',
  },
];
